import OrderTransportingOrderForwardingSendRequest, {
  OrderTransportingOrderForwardingSendRequestBody,
} from "./order-transporting-order-forwarding-send.request";

const createBody = (
  request: OrderTransportingOrderForwardingSendRequest,
): OrderTransportingOrderForwardingSendRequestBody => {
  return {
    contractId: request.contractId,
  };
};

const orderTransportingOrderSendForwardingRequestFactory = {
  createBody,
};

export default orderTransportingOrderSendForwardingRequestFactory;
